import LocationCodebookContainer from '@src/components/codebook/LocationCodebookContainer';
import React from 'react';

const AdminLocationCodebookPage = () => <LocationCodebookContainer />;

export default AdminLocationCodebookPage;
